import { useContractModalCta } from '#src/app/pages/ambassadors/landing/shared/hooks';

type Result = ModelHookResult<
	undefined,
	{
		handleCtaClick: () => void;
	}
>;

export function useHero(): Result {
	return {
		actions: {
			handleCtaClick: useContractModalCta('hero'),
		},
	};
}
